<div class="breadcrumb-wrapper" *ngIf="platformBreadcrumbs && platformBreadcrumbs?.length > 0">
  <ol class="breadcrumb-wrapper--item">
    <li> <a [routerLink]="['/home']" i18n="@@Home">Home</a>
    <li *ngFor="let platformBreadcrumb of platformBreadcrumbs; let i = index;">
      <span >/</span>
      <a *ngIf="(platformBreadcrumbs?.length-1) !== i && platformBreadcrumb?.dynamicLabel !== ' Search'" [routerLink]="[platformBreadcrumb?.url]">{{platformBreadcrumb?.dynamicLabel}}</a>

      <!--If previous route was /search use windows.history api see BreadcrumbComponent.goBack() -->
      <a class="search-breadcrumb" *ngIf="(platformBreadcrumbs?.length-1) !== i && platformBreadcrumb?.dynamicLabel === ' Search'" (click)="goBack()">{{platformBreadcrumb?.dynamicLabel}}</a>
      <a *ngIf="(platformBreadcrumbs?.length-1) === i">{{platformBreadcrumb?.dynamicLabel}}</a>
    </li>
  </ol>
</div> 
